import { render, staticRenderFns } from "./CreateChecklist.vue?vue&type=template&id=2072f509&scoped=true&"
import script from "./CreateChecklist.vue?vue&type=script&lang=js&"
export * from "./CreateChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072f509",
  null
  
)

export default component.exports